module.exports = __webpack_public_path__ + "static/img/sbxt.68409fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/sbxt.png
// module id = EZG5
// module chunks = 0